"use strict";

class StationSettingsTypeCtrl {
    constructor(datamodel, FieldTypes, $mdDialog, $rootScope, $scope, $state, $stateParams, widgets, $transitions) {
        this.datamodel = datamodel;
        this.FieldTypes = FieldTypes;
        this.$mdDialog = $mdDialog;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.widgets = widgets;

        this.type = null;
        this.field = null;
        this.templateUrl = null;


        this.$rootScope.saveDisabled = false;

        $scope.$watch(() => {
            return $scope.datamodelType.$invalid;
        }, (newVal) => {
            $rootScope.saveDisabled = newVal;
        });

        this.datamodel.isReady.then(this.fetch.bind(this));

        this.unregisterStateChangeStart = $transitions.onStart({}, this.stateChangeStart.bind(this));

        $scope.$on('$destroy', () => {
            this.unregisterStateChangeStart();
        });
    }

    applyError(index, error, value) {
        if (!this.field.options.$errors) {
            this.field.options.$errors = {};
        }
        if (!this.field.options.$errors[index]) {
            this.field.options.$errors[index] = {};
        }
        this.field.options.$errors[index][error] = value;
    }

    checkForDuplicated() {
        let values = this.field.options.values;
        for (let i in values) {
            if (values.hasOwnProperty(i)) {
                if (values[i] === '') {
                    this.applyError(i, 'required', true);
                } else {
                    this.applyError(i, 'required', false);
                    if (values.filter(val => values[i] == val).length > 1) {
                        this.applyError(i, 'duplicated', true);
                    } else {
                        this.applyError(i, 'duplicated', false);
                    }
                }
            }
        }
    }

    fetch() {
        //get the data for this id
        this.$scope.$apply(() => {

            let modelData = this.datamodel.data[this.$stateParams.modelName];

            for (let index in modelData) {
                if (!modelData.hasOwnProperty(index)) continue;

                if (modelData[index].id == this.$stateParams.typeId) {
                    this.type = modelData[index];
                    break;
                }
            }

            if (this.type) {
                for (let index in this.type.fields) {
                    if (!this.type.fields.hasOwnProperty(index)) continue;

                    if (this.type.fields[index].id == this.$stateParams.fieldId) {
                        this.field = this.type.fields[index];
                        //transform string in date object
                        if (this.field.field_type && (this.field.field_type.name == 'time' || this.field.field_type.name == 'date') && this.field.options.max) {
                            this.field.options.max = new Date(this.field.options.max);
                        }
                        if (this.field.field_type && (this.field.field_type.name == 'time' || this.field.field_type.name == 'date') && this.field.options.min) {
                            this.field.options.min = new Date(this.field.options.min);
                        }
                        break;
                    }
                }
            }

            if (this.type == null || this.field == null) {

                this.$scope.datamodelType.$invalid = false;
                this.$state.go('^');
                return;
            }

            let fieldsPromise = new Promise((resolve) => {
                this.FieldTypes.get((data) => {
                    this.fields = data.fields;
                    resolve(this.fields);
                })
            });
            let widgetsPromise = new Promise((resolve) => {
                this.widgets.getWidgetsByType('field').then((widgets) => {
                    this.fieldWidgets = widgets;
                    resolve(this.fieldWidgets);
                })
            });

            Promise.all([fieldsPromise, widgetsPromise]).then(([fields, widgets]) => {
                //set default if current field_type_id is not set
                if (this.field.field_type_id === undefined && this.field.widget_id === undefined) {

                    this.field.field_type_id = this.fields[0].id;
                    this.field.field_type = this.fields[0];
                    this.field.widget_id = 0;
                    this.field.widget = null;
                }

                if (this.field.field_type_id) {
                    let currentField;
                    for (let i in this.fields) {
                        if (this.fields[i].id == this.field.field_type_id) {
                            this.fieldTypeSelect = this.fields[i];
                            break;
                        }
                    }
                    this.templateUrl = '/partial/app.partials.stationsettings.datamodel.fields.' + this.field.field_type.name;
                } else {
                    if (this.field.widget && this.field.widget.id) {
                        for (let i in this.fieldWidgets) {
                            if (this.fieldWidgets[i].id == this.field.widget.id) {
                                this.fieldTypeSelect = this.fieldWidgets[i];
                                break;
                            }
                        }
                    }
                    this.loadingIncludeComplete();
                }
            })
        });
    }

    stateChangeStart(transition) {

        // If we are not already saving and the datamodel is indeed invalid
        if (!this.$rootScope.saving && this.$scope.datamodelType.$invalid) {

            // Prevent the default action
            transition.abort();

            // Show the message with info
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: "invalidField.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            });

        }
    }

    changedFieldType(field) {
        let isWidget = !!field.application_id;
        if (!isWidget && this.field.field_type_id != field.id) {
            this.field.field_type_id = field.id;
            this.field.field_type = field;
            this.field.widget_id = null;
            this.field.widget = null;
            this.field.options = {};

            //Load custom fields for this type
            this.templateUrl = '/partial/app.partials.stationsettings.datamodel.fields.' + this.field.field_type.name;
        } else if (isWidget && this.field.widget_id != field.id) {
            this.field.widget_id = field.id;
            this.field.widget = field;
            this.field.field_type_id = null;
            this.field.field_type = null;
            this.field.options = {};

            //Load custom fields for this widget
            this.templateUrl = '';
        }
    }

    sanitizeSystemName() {
        if (this.field.name) {
            let find = this.type.fields.find((element) => {
                return element.name.toLowerCase() == this.field.name.toLowerCase();
            });
            if (find["created_at"] === undefined && find["id"] == this.field.id) {
                this.field.name = this.field.name.trim().replace(/[^\w\d_]/gi, '').toLowerCase();
                this.$scope.datamodelType.systemName.$setValidity('unique', true);
            } else {
                this.$scope.datamodelType.systemName.$setValidity('unique', false);
            }
        }
    }

    loadingIncludeComplete() {
        //after loading and rendering
        this.loaded = true;
    }
}

StationSettingsTypeCtrl.$inject = [
    'datamodel',
    'FieldTypes',
    '$mdDialog',
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    'widgets',
    '$transitions',
];

module.exports = StationSettingsTypeCtrl;